import React, {
  useEffect,
  useState,
  useCallback
} from 'react';

import {
  useParams,
  useNavigate
} from 'react-router-dom';

import {
  FaArrowLeft,
  FaCheckCircle,
  FaImage,
  FaComments
} from 'react-icons/fa';

import { toast } from 'react-toastify';
import api from '../services/api';
import './ComplaintDetail.css';

const ComplaintDetail = () => {

  const { type, id } = useParams();
  const navigate = useNavigate();

  const [complaint, setComplaint] = useState(null);
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState('');
  const [remark, setRemark] = useState('');
  const [resolutionImage, setResolutionImage] = useState(null);
  const [updating, setUpdating] = useState(false);

 const fetchComplaint = useCallback(async () => {

  try {

    setLoading(true);

    let endpoint = "";

if (type === "complaint") {
    endpoint = `/api/complaints/${id}`;
}
else if (type === "request") {
    endpoint = `/api/service-requests/${id}`;
}
else {
    endpoint = `/api/suggestions/${id}`;
}

const res = await api.get(endpoint);

    const data =
      res?.data?.data ||
      res?.data;

    setComplaint(data);

    setStatus(data.status);

  } catch (err) {

    console.error(err);
    toast.error(
  type === "complaint"
    ? "Failed to load complaint"
    : "Failed to load service request"
);

  } finally {

    setLoading(false);
  }

},[id, type]);
  useEffect(() => {

    fetchComplaint();

  }, [fetchComplaint]);

  const handleUpdateStatus = async () => {

    if (!complaint) return;

    setUpdating(true);

    try {

      const formData = new FormData();

      formData.append(
        'status',
        status
      );

      if (remark) {
        formData.append(
          'comment',
          remark
        );
      }

      if (resolutionImage) {
        formData.append(
          'resolutionImage',
          resolutionImage
        );
      }

     let endpoint = "";

if (type === "complaint") {
  endpoint = `/api/complaints/${complaint.id}/status`;
}
else if (type === "request") {
  endpoint = `/api/service-requests/${complaint.id}/status`;
}

await api.put(
  endpoint,
  formData,
  {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  }
);

      toast.success(
        'Status updated successfully'
      );

      fetchComplaint();

    } catch (err) {

      console.error(err);
      toast.error(
        'Failed to update status'
      );

    } finally {

      setUpdating(false);
    }
  };

  if (loading) {
    return (
      <div className="loading-container">
        Loading...
      </div>
    );
  }
  console.log(complaint);

  if (!complaint) return null;

  return (
    <div className="modern-container">

      <button
        onClick={() =>
          navigate('/dashboard')
        }
        className="modern-back-btn"
      >
        <FaArrowLeft />
        Back to Dashboard
      </button>

      <div className="modern-grid">

        <div className="modern-left">

          <div className="modern-card">

            <h1>{complaint.title}</h1>

            <p>{complaint.description}</p>

            <hr />

            <p>
              <strong>Category:</strong>{' '}
              {complaint.category}
            </p>

            <p>
              <strong>Status:</strong>{' '}
              {complaint.status}
            </p>

            {type === "complaint" && (

<p>
  <strong>Priority:</strong>{" "}
  {complaint.priority}
</p>

)}

           {type === "complaint" && (

<button
  className="modern-update-btn"
  style={{ marginTop: "15px" }}
  onClick={() =>
    navigate(`/complaint-chat/${complaint.id}`)
  }
>
  <FaComments />
  {" "}Open Chat
</button>

)}
          </div>

                 {complaint.images?.length > 0 && (

            <div className="modern-card">

              <h3>
                <FaImage />
                {' '}Problem Photos
              </h3>

              <div className="image-grid">

                {complaint.images.map(
                  (img, index) => (
                    <img
                      key={index}
                      src={`http://localhost:8080${img}`}
                      alt="Complaint"
                    />
                  )
                )}

              </div>

            </div>
          )}

          {complaint.resolutionImage && (

  <div className="modern-card">

    <h3>
      <FaCheckCircle />
      {" "}Resolution Photo
    </h3>

    <div className="image-grid">

      <img
        src={`http://localhost:8080${complaint.resolutionImage}`}
        alt="Resolution"
      />

    </div>

  </div>

)}

          {/* Status Timeline */}

          {type === "complaint" &&
complaint.statusHistory?.length > 0 && (
            <div className="modern-card">

              <h3>Status Timeline</h3>

              {complaint.statusHistory.map((history, index) => (

                <div
                  key={index}
                  style={{
                    borderLeft: "4px solid #0d6efd",
                    paddingLeft: "15px",
                    marginBottom: "20px"
                  }}
                >

                  <h4>{history.status}</h4>

                  <small>
                    {new Date(history.updatedAt).toLocaleString()}
                  </small>

                  <p>{history.comment}</p>

                </div>

              ))}

            </div>

          )}

      

        </div>

        <div className="modern-right">

          <div className="modern-card">

            <h3>Update Status</h3>

            <select
              value={status}
              onChange={(e) =>
                setStatus(
                  e.target.value
                )
              }
            >
              <option value="OPEN">
                Open
              </option>

              <option value="IN_PROGRESS">
                In Progress
              </option>

              <option value="RESOLVED">
                Resolved
              </option>
            </select>

            <textarea
              placeholder="Add remark..."
              value={remark}
              onChange={(e) =>
                setRemark(
                  e.target.value
                )
              }
            />

            <input
              type="file"
              onChange={(e) =>
                setResolutionImage(
                  e.target.files[0]
                )
              }
            />

            <button
              onClick={
                handleUpdateStatus
              }
              disabled={updating}
              className="modern-update-btn"
            >
              <FaCheckCircle />

              {updating
                ? ' Updating...'
                : ' Update'}
            </button>

          </div>

        </div>

      </div>

    </div>
  );
};

export default ComplaintDetail;
